module.exports = __webpack_public_path__ + "static/img/banner.63badca.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/ptgames/banner.png
// module id = brcJ
// module chunks = 3